import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LoyaltyIcon from '@mui/icons-material/Loyalty';

const Bonificacion = () => {
  const theme = useTheme();

  const items = [
    {
      title: '4 historias en TNO Network',
      text: 'Publicación de 4 historias en el ecosistema TNO Network con enlace dofollow a tu sitio o redes.',
    },
    {
      title: 'Banner en la página del programa',
      text: 'Banner en la página de La Dosis Positiva en TNO Network (medida Glacier: 2001×701 px, mismo formato que el banner en OnDemand) con enlace dofollow.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={3} display="flex" alignItems="center" justifyContent="center" gap={1}>
        <LoyaltyIcon sx={{ fontSize: 32, color: theme.palette.primary.main }} />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 700 }}
          variant="h5"
          color="primary"
        >
          Bonificación (Plan Rotativa)
        </Typography>
      </Box>
      <Typography variant="body1" color="textSecondary" align="center" sx={{ mb: 3 }}>
        Incluido con el Plan Rotativa Network. Todo con enlaces dofollow.
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        {items.map((item, i) => (
          <Grid item xs={12} md={5} key={i}>
            <Card
              variant="outlined"
              sx={{
                border: `2px solid ${theme.palette.primary.light}`,
                height: '100%',
              }}
            >
              <CardContent>
                <Typography variant="subtitle1" fontWeight={700} color="primary" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Bonificacion;
